module.exports = __webpack_public_path__ + "img/586-587-plan.e1870584.jpg";